import { KeyValue } from "@/main/models/common";
import { ReportTemplateDomainRequest } from "@/main/models/request";
import { IInitialReducerData } from "@/main/services/reducerUtils";

export enum ReportTemplateTypes {
	GET_REPORT_TEMPLATE_DOMAIN = "@reportTemplate/GET_REPORT_TEMPLATE_DOMAIN",
	SAVE_REPORT_TEMPLATE_DOMAIN = "@reportTemplate/SAVE_REPORT_TEMPLATE_DOMAIN",
	RESET_REDUCER_REPORT_TEMPLATE = "@reportTemplate/RESET_REDUCER_REPORT_TEMPLATE",
}

export interface ReportTemplateState {
	readonly reportTemplateDomain: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
	readonly isolated: {
		[key: string]: IInitialReducerData;
	};
}

export interface GetReportTemplateDomain {
	type: typeof ReportTemplateTypes.GET_REPORT_TEMPLATE_DOMAIN;
	payload: {
		request: ReportTemplateDomainRequest;
		keyReducer: string;
	};
}

export interface SaveReportTemplateDomain {
	type: typeof ReportTemplateTypes.SAVE_REPORT_TEMPLATE_DOMAIN;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
		keyReducer: string;
	};
}

export interface ResetReducerReportTemplate {
	type: typeof ReportTemplateTypes.RESET_REDUCER_REPORT_TEMPLATE;
}

export type ReportTemplateActionTypes = GetReportTemplateDomain | SaveReportTemplateDomain | ResetReducerReportTemplate;
